import React, { useEffect, useContext, useState } from 'react'
import { Redirect } from 'react-router-dom'
// import { Session } from '../contexts/Session'
import { LanguageContext } from '../contexts/LanguageContext'
// import { HospitalBasicInfoContext } from '../contexts/HospitalBasicInfo'
import { Toast } from 'antd-mobile'
import request from '../utils/request'
export default function AuthRoute (props) {
  // const sdxUserToken = window.localStorage.getItem('sdxUserToken')
  const sdxHisCode = window.localStorage.getItem('sdxHisCode')
  const sdxPatPositionId = window.localStorage.getItem('sdxPatPositionId')
  const sdxUUID = window.localStorage.getItem('sdxUUID')
  // const sdxTokens = JSON.parse(window.localStorage.getItem('sdxTokens'))
  const sdxUserToken = window.localStorage.getItem('sdxUserToken')
  // const SessionContext = useContext(Session)
  const Language = useContext(LanguageContext)
  // const HospitalBasicInfo = useContext(HospitalBasicInfoContext)
  const [result, setResult] = useState(null)
  function GetCurrentUserBindState () {
    return request('/v1/orderers', {
      method: 'GET',
      headers: {
        'Accept-Language': Language.acceptLanguage
      }
    }).then(async (res) => {
      if (!res.error) {
        if (res.data.patientDTO === null) {
          if (sdxPatPositionId && sdxHisCode) {
            return <Redirect to={`/index/${sdxHisCode}/${sdxPatPositionId}`} />
          } else {
            return <Redirect to={`/index/${sdxHisCode}`} />
          }
        } else {
          return <props.item.component {...props.props} />
        }
      } else {
        if (res.message === 'invalid_token') {
          Toast.info('旧帐号已过期，请重新注册!')
          window.localStorage.removeItem('sdxUserToken')
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  }
  useEffect(() => {
    async function getState () {
      if (sdxUserToken) {
        setResult(await GetCurrentUserBindState())
      }
    }
    if (sdxUUID) {
      if (!result) {
        getState()
      }
    }

    return function clear () {
      return false
    }
  }, [])

  if (!sdxUserToken || !sdxUUID) {
    if (sdxPatPositionId && sdxHisCode) {
      return <Redirect to={`/index/${sdxHisCode}/${sdxPatPositionId}`} />
    } else {
      return <Redirect to={`/index/${sdxHisCode}`} />
    }
  } else {
    return result
  }
}
